import { api, readTotalCount } from '../api/client';
import { API_PACKAGES_URL } from '../utils';

/**
 * `{ rows, total }` — the versions of a package that were listed, newest first
 * (keepr-api KPR-1882): `{ version, change, date, current }`, `change`
 * `publish`, `rebuild` or `listing`, or null with `date` for a current version
 * nothing was recorded of. Anyone who may read the package may read these.
 */
export async function getPackageVersions(key) {
	const { data, headers } = await api.get(`${API_PACKAGES_URL}/${encodeURIComponent(key)}/versions`, { params: { limit: 200 } });
	const rows = Array.isArray(data) ? data : [];
	return { rows, total: readTotalCount(headers, rows.length) };
}
